import convert from "convert-units";
import { fetchWrapper } from "../app/RomeDataManager";
import { INITIAL_BREADTH, INITIAL_HEIGHT } from "../constant/constant";
import * as THREE from "three";
import {
  setLeftPosState,
  setMeasured,
  setRightPosState,
  setRoomSelectors,
  setUserHeight,
  setUserLength,
  setUserWidth,
} from "../features/drawing/drwingSlice";
import { setContextualMenuStatus, setUndoStack } from "./DrawingActions";
import { setShowFirstTimePopup } from "./PopupAction";
import { buildPointConnections } from "../utils/novaConnections";
let flag = false;

export const drawToolData = (floorplan_id) => {
  return async (dispatch, getState) => {
    const state = getState();
    const designStep = state.ApplicationState.designStep;
    const autoDraw = state.ApplicationState.autoDraw;
    const ScaleSetState = state.ApplicationState.ScaleSetState;

    let enableFirstTimePopup = state.PopupState.enableFirstTimePopup;
    let firstTimePopupNumber = state.PopupState.firstTimePopupNumber;
    const formData = new FormData();
    formData.append("floorplan_uuid", floorplan_id); // Assuming 'token' is the expected field name

    const requestOptions = {
      headers: {
        "Content-Type": "multipart/form-data", // Set content type as multipart/form-data
      },
    };

    try {
      // First make the initial API call to get floorplan data
      const response = await fetchWrapper.post(
        `/floorplans/floorplan_activities/draw`,
        formData,
        requestOptions
      );

      dispatch({
        type: "GET_DRAW_DATA",
        payload: response.data,
      });
      dispatch({
        type: "UPDATE_APPLICATION_STATE",
        floorplanId: floorplan_id,
        id: response.data.id,
        projecId: response.data.project_id,
        imageUri: response.data.image_uri,
      });

      // Process Nova draw data - first check response for nova_draw_data
      let autoDrawData;
      let parsedData;
      
      if (response.data.nova_draw_data) {
        // If nova_draw_data exists in initial response, use it
        autoDrawData = response.data.nova_draw_data;
        parsedData = JSON.parse(autoDrawData);
        dispatch(setAutoDrawData(parsedData));
      } 
      else {
        // If in autoDraw mode and no nova_draw_data in initial response, check nova API endpoint
        // try {
        //   const checkResponse = await fetchWrapper.get(
        //     `/floorplans/check_nova_draw_data/${floorplan_id}`
        //   );
          
        //   if (checkResponse.data?.status === "completed" && checkResponse.data?.nova_draw_data) {
        //     autoDrawData = checkResponse.data.nova_draw_data;
        //     parsedData = JSON.parse(autoDrawData);
        //     dispatch(setAutoDrawData(parsedData));
        //   }
        // } catch (error) {
        //   console.error("Error checking Nova draw data:", error);
        // }
      }

      // Process points if we have parsed Nova data
      if (parsedData) {
        const pointSet = new Set();
        const novaPointsArray = [];

        if (parsedData.lines && parsedData.lines.length > 0) {
          parsedData.lines.forEach(line => {
            if (line.startPoint) {
              const startKey = `${line.startPoint.x},${line.startPoint.y},${line.startPoint.z}`;
              if (!pointSet.has(startKey)) {
                pointSet.add(startKey);
                novaPointsArray.push(new THREE.Vector3(
                  line.startPoint.x,
                  line.startPoint.y,
                  line.startPoint.z
                ));
              }
            }
            if (line.endPoint) {
              const endKey = `${line.endPoint.x},${line.endPoint.y},${line.endPoint.z}`;
              if (!pointSet.has(endKey)) {
                pointSet.add(endKey);
                novaPointsArray.push(new THREE.Vector3(
                  line.endPoint.x,
                  line.endPoint.y,
                  line.endPoint.z
                ));
              }
            }
          });
        }

        // Convert to JSON structure with IDs
        const novaPoints = novaPointsArray.map((point, index) => ({
          id: index,
          point: new THREE.Vector3(point.x, point.y, point.z),
          x: point.x,
          y: point.y,
          z: point.z
        }));

        console.log("novaPoints", novaPoints);

        // Find the top-left point (minimum x and minimum y)
        if (novaPoints.length > 0) {
          const topLeftPoint = novaPoints.reduce((topLeft, item) => {
            if (item.x < topLeft.x || (item.x === topLeft.x && item.y < topLeft.y)) {
              return { x: item.x, y: item.y };
            }
            return topLeft;
          }, { x: novaPoints[0].x, y: novaPoints[0].y });

          dispatch(setNovaTopLeftPoint(topLeftPoint));
        }

        // Build point connections from lines
        const connections = buildPointConnections(parsedData.lines, novaPoints);

        // Store nova lines with their types
        const novaLines = parsedData.lines || [];

        dispatch(setNovaPoints(novaPoints));
        dispatch(setNovaPointConnections(connections));
        dispatch(setNovaLines(novaLines));
        //dispatch(setPoints(novaPoints));
      }

      // Handle draw tool guidance and tutorial settings
      if (response.data?.draw_tool_guidance === "1") {
        enableFirstTimePopup = false;
        dispatch(setShowFirstTimePopup({enableFirstTimePopup: enableFirstTimePopup}));
      }
      if (response.data?.draw_tool_tutorial === "0") {
        dispatch(toggleTutorial(true));
      }

      // Process the main draw data
      let drawData = JSON.parse(response.data.draw_data);
      if (autoDraw && response.data.nova_draw_data) {
        //drawData = JSON.parse(response.data.nova_draw_data);
      }

      // Process lines from draw data
      let lines = [];
      let point = [];
      if (drawData && drawData.lines && drawData.lines.length > 0) {
        lines = drawData.lines.map((line) => ({
          id: line.id,
          points: [
            new THREE.Vector3(
              line.startPoint.x,
              line.startPoint.y,
              line.startPoint.z
            ),
            new THREE.Vector3(
              line.endPoint.x,
              line.endPoint.y,
              line.endPoint.z
            ),
          ],
          length: line.length,
          width: line.width,
          height: line.height,
          widthchangetype: line.widthchangetype,
          widthchange: line.widthchange,
          type: line.type,
          typeId: line.typeId,
          locked: line.locked
        }));
      }

      // Process points from draw data
      if (drawData && drawData.points && drawData.points.length > 0) {
        point = drawData.points.map(
          (point) => new THREE.Vector3(point.x, point.y, point.z)
        );
      }

      // Dispatch the processed lines and points
      if (lines && lines.length > 0) {
        dispatch(setStoreLines(lines));
      }
      if (point && point.length > 0) {
        //dispatch(setPoints(point));
      }

      // Handle tutorial backup if needed
      if (lines.length > 0 && response.data?.draw_tool_tutorial === "0") {
        dispatch(backupLinesAndPoints()); // backup lines and points to show after tutorial because using same storeLines and points for tutorial
      }

      // Process rooms data if available
      if (drawData?.rooms && drawData?.rooms?.length > 0) {
        dispatch(setRoomSelectors(drawData.rooms));
      }

      // Process store boxes if available
      if (drawData?.storeBoxes && drawData?.storeBoxes?.length > 0) {
        dispatch(setStoreBoxes(drawData.storeBoxes));
      }

      // Handle popup status
      if (drawData?.firstTimePopupStatus) {
        firstTimePopupNumber = drawData.firstTimePopupStatus;
        if (!ScaleSetState){
          dispatch(setShowFirstTimePopup({firstTimePopupNumber: firstTimePopupNumber}));
        }
      }

      // Handle escape message show status
      if (drawData?.escapeMessageShow === false) {
        dispatch(setEscapeMessageShow(drawData.escapeMessageShow));
      }

      // Process scale data if available
      if (response.data.scale !== null) {
        const scaleData = JSON.parse(response.data.scale);
        const measured = scaleData?.userUnit || "mm";
        dispatch(setMeasured(measured));
        let userHeight = scaleData?.userHeight;
        let userLength = scaleData?.unitLength;
        let userWidth = scaleData?.userWidth;
        
        // Convert to feet if needed
        if (measured === "ft") {
          userLength = convert(userLength).from("in").to("ft");
          userWidth = convert(userWidth).from("in").to("ft");
        }
        
        
        dispatch(setUserLength(userLength));
        dispatch(setUserWidth(userWidth));
        dispatch(setUserHeight(userHeight));
        
        // Set left and right position states
        const left = {
          x: scaleData.leftPos.x,
          y: scaleData.leftPos.y,
          z: scaleData.leftPos.z
        };
        const right = {
          x: scaleData.rightPos.x,
          y: scaleData.rightPos.y,
          z: scaleData.rightPos.z
        };
        
        dispatch(setLeftPosState(left));
        dispatch(setRightPosState(right));
        
        // Set scale line ID if it exists in the scale data
        if (scaleData.scaleLineId) {
          dispatch(setScaleLine(scaleData.scaleLineId));
        }
        
        // Calculate and set factors
        const lfactor = userLength / scaleData.distance;
        const wfactor = INITIAL_BREADTH;
        const hfactor = INITIAL_HEIGHT / userHeight;
        dispatch(setFactor([lfactor, wfactor, hfactor]));
        
        // Handle design step transitions
        if (designStep === 1) {
          dispatch(setDesignStep(2));
        }
        
        // Show appropriate first time popups based on design step
        if ((designStep === 1 || designStep === 2) && enableFirstTimePopup && firstTimePopupNumber <= 2) {
          dispatch(setShowFirstTimePopup({
            showFirstTimePopup: true,
            firstTimePopupType: "ui",
            firstTimePopupNumber: 3,
            popupDismissable: false
          }));
        } else if (designStep === 3 && enableFirstTimePopup && drawData.rooms.length > 0) {
          dispatch(setShowFirstTimePopup({
            showFirstTimePopup: true,
            firstTimePopupType: "ui",
            firstTimePopupNumber: 6,
            popupDismissable: false
          }));
        }
      } else {
        // Handle case when no scale data is available
        if (designStep === 1 && enableFirstTimePopup && firstTimePopupNumber <= 1 && response.data.image_uri) {
          // dispatch(setShowFirstTimePopup({
          //   showFirstTimePopup: true,
          //   firstTimePopupType: "canvas",
          //   firstTimePopupNumber: 1,
          //   popupDismissable: true
          // }));
        }
      }

      // Handle case when image URI exists but no scale data
      if (response.data.image_uri && response.data.scale === null) {
        dispatch(setDesignStep(2));
        // dispatch(setShowFirstTimePopup({
        //   showFirstTimePopup: true,
        //   firstTimePopupType: "ui",
        //   firstTimePopupNumber: 3,
        //   popupDismissable: false
        // }));
      }

      // Handle case when no image URI exists
      if (!response.data.image_uri && flag == false) {
        dispatch(setDesignStep(2));
        dispatch(setShowSetScalePopup(true));
        flag = true;
      }

    } catch (error) {
      console.error("Error", error);
    }
  };
};

export const setUserRole = (role) => {
  return (dispatch) => {
    dispatch({
      type: "SET_USER_ROLE",
      payload: role,
    });
  }
}

export const updateDrawData = (data, floorplanId) => {
  return (dispatch) => {
    fetchWrapper
      .post(`/floorplans/update_draw_data`, data)
      .then((response) => {
        dispatch({
          type: "UPDATE_DRAW_DATA",
          payload: response.data,
        });
        dispatch(drawToolData(floorplanId));
      })
      .catch((error) => {
        console.error("Error", error);
      });
  };
};

export const setStoreLines = (lines) => {
  return (dispatch) => {
    dispatch({
      type: "SET_STORE_LINES",
      payload: lines,
    });
  };
};

export const setStoreBoxes = (box) => {
  return (dispatch) => {
    dispatch({
      type: "SET_STORE_BOXES",
      payload: box,
    });
  };
};

export const setPoints = (points) => {
  return (dispatch) => {
    dispatch({
      type: "SET_POINTS",
      payload: points,
    });
  };
};

export const setFactor = (factor) => {
  return (dispatch) => {
    dispatch({
      type: "SET_FACTOR",
      payload: factor,
    });
  };
};

export const updateLineTypeId = (typeId) => {
  return (dispatch, getState) => {
    let type =
      typeId === 1
        ? "wall"
        : typeId === 2
        ? "door"
        : typeId === 3
        ? "window"
        : typeId === 4
        ? "railing"
        : typeId === 5
        ? "imaginary"
        : typeId === 6
        ? "firstLine"
        : typeId === 7
        ? "sliding_window"
        : "";
    const state = getState();
    const selectedLines = [...state.ApplicationState.selectedLines];
    const selectionMode = state.ApplicationState.selectionMode;
    const storeLines = [...state.ApplicationState.storeLines];
    if (selectionMode && selectedLines) {
        const updateLines = storeLines.map(line => {
            const matchingSelectedLine = selectedLines.find(selectedLine => selectedLine === line.id);
            if (matchingSelectedLine) {
              return {
                ...line,
                typeId,  
                type
              };
            }
            return line; // Keep the line unchanged if no match is found
        }); 
        const history = [...state.Drawing.actionHistory]
        history.push({
          type: 'replace',
          previousLines: [...storeLines],
          currentLines: updateLines,
        })
        dispatch(setUndoStack(history))
        dispatch(setStoreLines(updateLines)) 
        dispatch(setContextualMenuStatus(false))        
    } else {
      const measured = state.drawing.measured
      const lineIndex = storeLines.length - 1;
      if (lineIndex !== -1) {
        storeLines[lineIndex] = {
          ...storeLines[lineIndex], // Create a copy of the line object
          typeId, // Update the typeId
          type,
        };
        // dispatch({
        //   type: "SET_PROPERTY_POPUP",
        //   payload: true,
        // });
        // const length = convert(storeLines[lineIndex].length).from('mm').to(measured)
        // const width = convert(storeLines[lineIndex].width).from('mm').to(measured)
        // dispatch({
        //   type: "SET_LENGTH",
        //   payload: length,
        // });
        // dispatch({
        //   type: "SET_WIDTH",
        //   payload: width,
        // });
        // Dispatch an action to update the state in the Redux store
        dispatch(setStoreLines(storeLines));
      }
    }
  };
};

export const showRoomNamePopup = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SHOW_ROOM_NAME_POPUP",
      payload: value,
    });
  };
};

export const setExpandRoomNamePopup = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_EXPAND_ROOM_NAME_POPUP",
      payload: value,
    });
  };
};

export const setRoomEditingMode = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      roomEditingMode: value,
    });
  };
};

export const setRoomName = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      selectedRoomName: value,
    });
  };
};

export const setRoomDetails = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      selectedRoomType: value,
    });
  };
};

export const setActiveRoomButton = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      activeRoomButton: value,
    });
  };
};

export const setActiveRoomIndex = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      activeRoomIndex: value,
    });
  };
};

export const setSelectionMode = (val) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SELECTION_MODE",
      payload: val,
    });
  };
};

export const setSelectedLinesState = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      selectedLines: val,
    });
  };
};

//SetScaleSet action
export const setScaleSetState = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      ScaleSetState: value
    });
  };
};

//AutoDraw State
export const setAutoDraw = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_AUTO_DRAW",
      payload: value,
    });
  };
};

export const setDesignStep = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      designStep: val
    })
  }
}

export const setImageOpacity = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      imageOpacity: val
    })
  }
}

export const setShowSetScalePopup = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      showSetScalePopup: val
    })
  }
}

export const setScaleLine = (scaleLineId) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCALE_LINE_ID",
      payload: scaleLineId,
    });
  };
};

export const setNovaPoints = (points) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_NOVA_POINTS',
      payload: points,
    });
  };
};

export const setNovaTopLeftPoint = (point) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_NOVA_TOP_LEFT_POINT',
      payload: point,
    });
  };
};

export const setNovaPointConnections = (connections) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_NOVA_POINT_CONNECTIONS',
      payload: connections,
    });
  };
};

export const setNovaLines = (lines) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_NOVA_LINES',
      payload: lines,
    });
  };
};

export const setFirstLinePoints = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      firstLinePoints: val
    })
  }
}

export const setHelpVideo = (val, type = "") => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      helpVideo: val,
      helpVideoType: type
    })
  }
}

export const setEscapeMessageShow = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      escapeMessageShow: val
    })
  }
}

export const setUserStatus = () => {
  return (dispatch) => {
    const formData = new FormData();
    formData.append('status', "1")
    fetchWrapper.post('/user_preferences/data_tool_guidance', formData)
    dispatch(setShowFirstTimePopup({enableFirstTimePopup: false}))
  }
}

export const setHelpVideoNumberr = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      helpVideoNumber: val
    })
  }
}

export const setHelpPopup = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      helpPopup: val
    })
  }
}

export const showRoomSeperatorPopup = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      roomSeperatorPopup: value,
    });
  };
};


export const setShowUpgradePopup = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      showUpgradePopup: value,
    });
  };
};

export const setShowPaymentConfirmationPopup = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      showPaymentConfirmationPopup: value,
    });
  };
};

export const setShowInstructionPopup = (value) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      showInstructionPopup: value,
    });
  };
};

export const toggleTutorial = (val) => {
  return (dispatch) => {
    if(val == false){
      const formData = new FormData();
      formData.append('status', "1")
      fetchWrapper.post('/user_preferences/data_tool_tutorial', formData)
    }
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      tutorialActive: val,
    });
  };
};

export const setAutoDrawData = (data) => ({
  type: 'SET_AUTO_DRAW_DATA',
  payload: data
});

export const backupLinesAndPoints = () => {
  return (dispatch, getState) => {
    const state = getState();
    const lines = [...state.ApplicationState.storeLines];
    const points = [...state.ApplicationState.points];
    console.log("backupLinesAndPoints", lines, points);
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      backupLines: lines,
      backupPoints: points,
      storeLines: [],
      points: [],
    })
  }
}

export const restoreLinesAndPoints = () => {
  return (dispatch, getState) => {
    const state = getState();
    const lines = [...state.ApplicationState.backupLines];
    const points = [...state.ApplicationState.backupPoints];

    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      storeLines: lines,
      points: points,
      backupLines: [],
      backupPoints: [],
    })
  }
}

export const setHighlightMenu = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      highlightMenu: val
    })
  }
}

export const setHighlightPoint = (val) => {
  return (dispatch) => {
    dispatch({
      type: "UPDATE_APPLICATION_STATE",
      highlightPoint: val
    })
  }
}
